import { NextCBprops } from '../../authentication/wizard/types';
import { FBMOverCarousel, RedeemedDepositFreespin, RedeemFreeMoneyBonus } from '../types';
import { RootState } from '~/store/types';
import { Item } from '~/components/item-detail-view/item-detail-view-types';
import { BONUS_REDUCER_NAME } from './constants';

export type BonusesState = {
	[BONUS_REDUCER_NAME]: {
		excludedGamesForId: number[];
		activeBonusDetails: Item;
		excludedGamesForIdAreLoading: boolean;
		includedGamesForId: number[];
		includedGamesForIdAreLoading: boolean;
		availableDepositOffers: Item[];
		availableWelcomeBonusPackages: Item[];
		isBonusModalOpen: boolean;
		depositFreespinSuccess: boolean;
		depositFreebetSuccess: boolean;
		depositOptInSuccess: boolean;
		loading: boolean;
		redeemedDepositFreespin: RedeemedDepositFreespin;
		allowedForMethod: boolean;
		selectedDepositFreespin: Item;
		selectedDepositFreebet: Item;
		selectedDepositOptIn: Item;
		isRedeemingDepositFreebet: boolean;
		isRedeemingDepositOptIn: boolean;
		isDepositBonusLoading: boolean;
		continuePendingNavigation: boolean;
		redeemFreeMoneyBonus: RedeemFreeMoneyBonus;
		bonusId: number;
		selectedWelcomePackageId: number;
		bonusAddOnId: number;
		bonusAddOnOptionsId: number;
		onSelectBonus: (id: number) => void;
		onSelectFreeMoneyBonus: (id: number) => void;
		nextStep: NextCBprops;
		paginate: (props?: NextCBprops | string) => void;
		parentGoToNext: () => void;
		playerRemainingBonusBalance: number;
		hasBonusError: boolean;
		oneClickOptInMessageOpen: boolean;
		bonusMaxStakeMessageOpen: boolean;
		bonusMaxStakeMessageContent: {
			maxStakeAmount: number;
			currency: string;
		};
		bonusesHydrated: boolean;
		bonusSkipped: boolean;
		preSelectedBonus: Item;
		isPreSelectedBonusLoading: boolean;
		hasPreSelectedBonusFailure: boolean;
		fmbOverCarousel: FBMOverCarousel;
		hasFmbFailure: boolean;
		isFmbLoading: boolean;
		checkBonusFailurePayload: { errorDescription: string; errorCode: string } | undefined;
		paymentMethodIdsStr: string;
		bonusSplitCategory: string;
		hydrated: boolean;
		bid: number;
		baid: number;
		oid: number;
	};
};

// Selectors
export const selectBonuses = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME];
export const selectExcludedGamesById = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].excludedGamesForId;
export const selectActiveBonusDetails = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].activeBonusDetails;
export const selectExcludedGamesForIdAreLoading = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].excludedGamesForIdAreLoading;
export const selectIncludedGamesById = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].includedGamesForId;
export const selectIncludedGamesForIdAreLoading = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].includedGamesForIdAreLoading;

export const selectAvailableDepositOffers = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].availableDepositOffers;
export const selectAvailableWelcomeBonusPackages = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].availableWelcomeBonusPackages;
export const selectIsBonusModalOpen = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].isBonusModalOpen;

export const selectHasBonusOffers = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].availableDepositOffers.length > 0 ||
	(state as BonusesState)[BONUS_REDUCER_NAME].availableWelcomeBonusPackages.length > 0;
export const selectDepositFreespinSuccess = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].depositFreespinSuccess;
export const selectDepositFreebetSuccess = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].depositFreebetSuccess;
export const selectDepositOptInSuccess = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].depositOptInSuccess;
export const selectBonusLoading = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].loading;
export const selectRedeemedDepositFreespin = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].redeemedDepositFreespin;
export const selectHasDepositOffersLoaded = (state: RootState) => !(state as BonusesState)[BONUS_REDUCER_NAME].loading;
export const selectAllowedForMethod = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].allowedForMethod;
export const selectSelectedDepositFreespin = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].selectedDepositFreespin;
export const selectSelectedDepositFreebet = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].selectedDepositFreebet;
export const selectSelectedDepositOptIn = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].selectedDepositOptIn;
export const selectIsRedeemingDepositFreebet = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].isRedeemingDepositFreebet;
export const selectIsRedeemingDepositOptIn = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].isRedeemingDepositOptIn;
export const selectIsDepositBonusLoading = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].isDepositBonusLoading;
export const selectContinuePendingNavigation = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].continuePendingNavigation;
export const selectRedeemFreeMoneyBonus = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].redeemFreeMoneyBonus;
export const selectBonusId = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].bonusId;
export const selectWelcomeBonusPackageId = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].selectedWelcomePackageId;
export const selectBonusAddOnId = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].bonusAddOnId;
export const selectBonusAddOnOptionsId = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].bonusAddOnOptionsId;
export const selectOnSelectBonus = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].onSelectBonus;
export const selectOnSelectFreeMoneyBonus = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].onSelectFreeMoneyBonus;
export const selectNextStep = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].nextStep;
export const selectPaginate = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].paginate;
export const selectParentGoToNext = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].parentGoToNext;

export const selectPlayerRemainingBonusBalance = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].playerRemainingBonusBalance;
export const selectHasBonusError = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].hasBonusError;
export const selectOptInMessageOpen = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].oneClickOptInMessageOpen;
export const selectBonusMaxStakeMessageOpen = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].bonusMaxStakeMessageOpen;
export const selectBonusMaxStakeMessageContent = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].bonusMaxStakeMessageContent;
export const selectBonusesHydrated = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].bonusesHydrated;
export const selectBonusSkipped = (state: RootState) => (state as BonusesState)[BONUS_REDUCER_NAME].bonusSkipped;
export const selectPreSelectedBonus = (state: RootState) => ({
	preSelectedBonus: (state as BonusesState)[BONUS_REDUCER_NAME].preSelectedBonus
		? { ...(state as BonusesState)[BONUS_REDUCER_NAME].preSelectedBonus }
		: null,
	isPreSelectedBonusLoading: (state as BonusesState)[BONUS_REDUCER_NAME].isPreSelectedBonusLoading,
	hasPreSelectedBonusFailure: (state as BonusesState)[BONUS_REDUCER_NAME].hasPreSelectedBonusFailure
});
export const selectFmbOverCarousel = (state: RootState) => ({
	...(state as BonusesState)[BONUS_REDUCER_NAME].fmbOverCarousel,
	hasFailure: (state as BonusesState)[BONUS_REDUCER_NAME].hasFmbFailure,
	isLoading: (state as BonusesState)[BONUS_REDUCER_NAME].isFmbLoading
});
export const selectCheckBonusFailure = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].checkBonusFailurePayload;
export const selectPaymentMethodIdsStr = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].paymentMethodIdsStr;
export const selectBonusSplitCategory = (state: RootState) =>
	(state as BonusesState)[BONUS_REDUCER_NAME].bonusSplitCategory;
